import { Outlet } from "react-router-dom";
import NeedhamBrand from "./Components/NeedhamBrand";
import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import "./css/LandingPage.css";



export default function AppLayout() {
    const [showTopButton, setShowTopButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => setShowTopButton(window.scrollY > 300);
        window.addEventListener("scroll", handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <Outlet />

  <footer className="landing-footer">
  <div className="footer-inner">
    <div className="footer-col footer-col-left">
  <p>
    <strong>Phone:</strong>{" "}
    <span
      style={{
        fontWeight: 900,
        fontSize: "1.2rem",
        letterSpacing: "0.03em",
        whiteSpace: "nowrap",
      }}
    >
      (859) 803-3043
    </span>
  </p>

  <p>
    <strong>Email:</strong>{" "}
    <a href="mailto:brookeroscoe@kw.com">brookeroscoe@kw.com</a>
  </p>

  <p><strong>LIC#:</strong> 260318</p>
</div>

    <div className="footer-col footer-col-center footer-logo">
      <a
        href="https://kentuckyhomeliving.kw.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/kw_logo3.png"
          alt="Keller Williams Realty Services"
          className="kw-footer-logo"
        />
      </a>
    </div>

    <div className="footer-col footer-col-right">
      <p><strong>Office:</strong> (859) 240-0727</p>
      <p><strong>Address:</strong> 7210 Turfway Rd, Florence, KY 41042</p>
    </div>
  </div>

  <p className="footer-disclaimer">
    Each Keller Williams Office is Independently Owned and Operated. If you have a brokerage
    relationship with another agency, this material is not intended as a solicitation.
    Information is reliable but not guaranteed and should not be considered legal or financial advice.
  </p>

  <div className="footer-bottom">
    <p className="footer-copy">© {new Date().getFullYear()} Kentucky Home Living</p>
    <div className="footer-compliance">
      <img src="/imgs/legal_logos.png" alt="Compliance logos" />
    </div>
  </div>

  {showTopButton && (
    <button
      className="back-to-top show"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
    >
      <FaArrowUp />
    </button>
  )}
</footer>

            <NeedhamBrand />
        </>
    );
}
